import * as React from 'react';

import {Button} from 'shells/button/button';
import {CheckboxButton} from 'shells/button/checkbox-button/checkbox-button';
import {PaperPlane} from 'shells/icon';
import type {SalesDocumentType} from 'shells/lead-sidebar/sales-documents/types';
import {Modal} from 'shells/modal/modal';
import {Body} from 'shells/typography/body';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';

type Props = {
    setIsStatusFollowupOpen: (isStatusFollowupOpen: boolean) => void;
    isStatusFollowupOpen: boolean;
    onDismissStatusFollowup: () => Promise<any>;
    handleUpdateStatus: (status: QuoteDisplayStatus) => void;
    type: SalesDocumentType;
};

export function QuoteStatusOnboarding(props: Props) {
    const [doNotShowStatusFollowup, setDoNotShowStatusFollowup] = React.useState<boolean>(false);

    const handleDismissStatusFollowup = () => {
        if (doNotShowStatusFollowup && props.onDismissStatusFollowup) {
            props.onDismissStatusFollowup();
        }
    };

    return (
        <Modal
            isOpen={props.isStatusFollowupOpen}
            onClose={() => {
                props.setIsStatusFollowupOpen(false);
                handleDismissStatusFollowup();
            }}
            headerText='Awesome!'
            fitHeight={true}
            // @ts-expect-error
            maxWidth='450px'
            // @ts-expect-error
            minWidth='450px'
            isCentered={true}
        >
            <div className='flex flex-dir-col gap-16'>
                <Body size='large'>
                    Once your lead has received your {props.type.toLowerCase()}, mark it as sent to
                    move on to the final stage.
                </Body>
                <div className='flex justify-sb mb-16'>
                    <CheckboxButton
                        checked={doNotShowStatusFollowup}
                        onChange={setDoNotShowStatusFollowup}
                        label='Do not show again'
                    />
                    <Button
                        icon={PaperPlane}
                        variant='primary'
                        size='big'
                        fitContent={true}
                        onClick={() => {
                            props.setIsStatusFollowupOpen(false);
                            props.handleUpdateStatus('SENT');
                            handleDismissStatusFollowup();
                        }}
                        onBlur={handleDismissStatusFollowup}
                    >
                        Mark as sent
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
